<template>
   <section class="couponGuideDialogWrap">
    <el-dialog
      :visible.sync="showCouponGuide" 
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width ="732px"
      custom-class = "couponGuideDialog"
    >
			<div class="couponsWrap">
        <div class="categor">直接制券</div>
        <ul>
          <li v-for="cards in couponTemplateData.coupons" :key="cards.key">
              <CouponGuideCard
                :cardsData = "cards"
                :curCardKey="curCardKey"
                v-on:listenCardClick="cardClickHandle"
              ></CouponGuideCard>
          </li>
        </ul>
        <div class="categor">模版制券</div>
        <ul>
          <li v-for="cards in couponTemplateData.templateCoupons" :key="cards.key">
              <CouponGuideCard
                :cardsData = "cards"
                :curCardKey="curCardKey"
                v-on:listenCardClick="cardClickHandle"
              ></CouponGuideCard>
          </li>
        </ul>
        <!-- <div class="categor">个性化定制</div>
        <ul>
          <li v-for="cards in couponTemplateData.customCoupons" :key="cards.key">
              <CouponGuideCard
                :cardsData = "cards"
                :curCardKey="curCardKey"
                :ishref= true
                v-on:listenCardClick="cardClickHandle"
              ></CouponGuideCard>
          </li>
        </ul> -->
			</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.prevent.stop="cancelClickHandler">取消</el-button>
        <el-button type="primary" @click.prevent.stop="submitClickHandler">确认</el-button>
      </div>
    </el-dialog>
   </section>
</template>

<script>
import CouponGuideCard from './CouponGuideCard.vue'
import iconCar from "Images/iconCar.png"
import iconDaijia from "Images/iconDaijia.png"
import iconSence from "Images/iconSence.png"
const INIT_GUDID_DATA={
  "car":{
    productId:210,
  },
  "daijia":{
    productId:120,
  },
  "t1":{
    productId:210,
    couponAmount:30,
    payType:1,
    addressRadio:'3',
    fenceType:'3',
    templateDataFrom:'t1'
  },
  "t2":{
    productId:200,
    couponAmount:100,
    payType:0,
    addressRadio:'3',
    fenceType:'4',
    templateDataFrom:'t2'
  },
  "t3":{
    productId:210,
    couponAmount:10,
    payType:1,
  },
  "t4":{
    productId:200,
    couponAmount:260,
    payType:0,
  },
  "t5":{
    productId:200,
    couponAmount:100,
    payType:0,
  },
  "t6":{
    productId:120,
    couponAmount:58,
    payType:0,
  },
}
export default {
  name: 'CouponGuide',
  componentName: 'CouponGuide',
  components:{
    CouponGuideCard
  },
  data(){
    return {
      showCouponGuide:true,
      couponTemplateData:{
        coupons:[{
          title:'网约车',
          content:"支持快、专、豪、通用多种类型",
          icon:iconCar,
          key:"car",
        },{
          title:'代驾',
          content:"支持代驾",
          icon:iconDaijia,
          key:"daijia"
        }],
        templateCoupons:[{
          title:'营销到店优惠',
          content:"·网约车·定额抵扣·地点限制",
          icon:iconCar,
          key:"t1", 
        },{
          title:'高净值客户到店往返',
          content:"·网约车·定额抵扣·地点限制",
          icon:iconCar,
          key:"t2", 
        },{
          title:'营销活动、会员权益',
          content:"·网约车·定额抵扣",
          icon:iconCar,
          key:"t3", 
        },
        // {
        //   title:'接送机',
        //   content:"·网约车·定额抵扣·地点限制",
        //   icon:iconCar,
        //   key:"t4", 
        // },
        {
          title:'车辆维修代步',
          content:"·网约车·定额抵扣",
          icon:iconCar,
          key:"t5", 
        },{
          title:'代驾送车',
          content:"·代驾·定额抵扣",
          icon:iconDaijia,
          key:"t6", 
        }],
        customCoupons:[{
          title:'出行券API对接',
          content:"快速对接、自有系统闭环、个性化",
          icon:iconSence,
          key:"c1",
          href:'https://dpubstatic.udache.com/static/dpubimg/1cb3277b27c2dc62d65fc1e71eaa5b55/index.html'
        },{
          title:'礼品卡采购',
          content:"实体卡/虚拟卡、多次抵扣",
          icon:iconSence,
          key:"c2",
          href:'https://dpubstatic.udache.com/static/dpubimg/34b507a60ea4151cccef8a8324db2a37/index.html'
        }],
      },
      curCardKey:'car',
      curCardTitle:'网约车'
    }
  },
  methods:{
    cardClickHandle:function(key,title){
      this.curCardKey = key
      this.curCardTitle = title
      this.omgTrack('es_chuxingquan_buy_formwork_ck', '出行券_购券管理_模版_点击',{content:title})
    },
    submitClickHandler:function(){
      let templateData  = INIT_GUDID_DATA[this.curCardKey]
      this.omgTrack('es_chuxingquan_model_confirm_ck', '出行券_模版_确认按钮点击',{content:this.curCardTitle})
      this.$store.commit('purchase/SET_ORDERINFO_FROM_GUIDE', templateData)
      this.showCouponGuide = false
    },
    cancelClickHandler:function(){
      this.showCouponGuide = false
      this.omgTrack('es_chuxingquan_model_cancel_ck', '出行券_模版_取消按钮点击')
    }
  },
  mounted: function () {
    this.omgTrack('es_chuxingquan_buy_formwork_sw', '出行券_购券管理_模版_曝光')
  }
}
</script>

<style lang="stylus">
.couponGuideDialogWrap{ 
  .el-dialog__body{
    padding: 0 20px
  }
  .couponsWrap{
    .categor{
      font-size: 14px;
      color: #333;
      font-weight: 500;
      padding-bottom: 10px
    }
    ul{
      width: 710px;
      display: flex;
      align-items: center;
      justify-content: flex-start
      flex-wrap: wrap;
      li{
        margin: 0 10px 10px 0;
         
      }
    }
  }
  .dialog-footer{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
